module.exports = __webpack_public_path__ + "media/images/ui__arrowDownInactive--dark-e5b2e9d01882de3897366b0617cf6b15.png";